<template>
  <div ref="maindiv" id="addeditcontent">

    <vs-button
      id="back-to-topic_btn"
      @click="backToTopic"
      icon-pack="feather"
      icon="icon-arrow-left"
      class="float-left mb-3 school-primary_gradient glow-effect_tertiary">
      Back
    </vs-button>

    <div class="main-div">
      <div class="vx-row limit-width_fixed-scalable">
        <div style="margin:auto" class="mb-4">
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
            <vx-input-group>
              <vs-button
                :disabled="true"
                size="large"
                style="width: 400px; padding-right: 0 !important;"
                class="button__fully-opaque glow-effect_bg-color__blend header_button-lookalike text__school-font-color bg-color"
                type="filled"
                color="">
                Adding an External Link
              </vs-button>
            </vx-input-group>
          </vx-card>

          <vx-card card-background="#11193f" class="text-left glow-effect_dark limit-width_uploader card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="LinkIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-input id="link-input" placeholder="Paste link here..." v-model="url" />
            </vx-input-group>
          </vx-card>
        </div>
      </div>

      <div>
        <div class="vx-row" id="linkDetails">
          <div class="vx-col pb-3 w-full sm:w-1/2 md:w-1/2">
            <label style="color:rgb(202, 202, 202);">Title</label>
            <vs-input autocomplete="off" id="linkName" class="w-full" v-model="linkName"/>
          </div>
          <div class="vx-col w-full sm:w-1/2 md:w-1/2">
            <label class="pl-4" style="color:rgb(202, 202, 202);">Description</label>
            <vs-textarea id="linkDesc" class="" v-model="linkDesc" />
          </div>
        </div>
      </div>

    </div>

    <locations
      :isLocationViewActive="isLocationViewActive"
      :selectedData="selectedData"
      :uploadedFileUrl="url"
      @save="save"
    />

  </div>
</template>

<script>
import Locations from './Locations.vue';
export default {
  components: {
    Locations
  },
  data() {
    return {
      isLocationViewActive: true,
      linkName: "",
      linkDesc: "",
      url: "",
      selectedData: {},
      numberOfTasks: null,
      isTeacher: false
    };
  },
  methods: {
    initValues() {
      var self = this;
      self.linkName = "";
      self.linkDesc = "";
      self.url = "";
    },
    save(allLocations) {
      var self = this;
      if(self.linkName && self.linkDesc) {
        self.showLoadingOnElement('maindiv', 1, 'material');

        var linkToAddInfo = {
          name: self.linkName,
          description: self.linkDesc,
          url: self.url,
          modules: allLocations,
          number: self.numberOfTasks + 1
        };

        var onSuccess = response => {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: `External Link saved & added to ${allLocations.length} location(s).`,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-save'
          });
          self.backToTopic();
        };
        var onFinally = function (){
          self.$vs.loading.close(self.$refs.maindiv.$el);
        };

        self.$ajaxPost(self, "ExternalLinkTask/AddEditStandaloneExternalLinkTask", linkToAddInfo, onSuccess, onFinally);
      }
      else {
        self.$vs.notify({
          title:'Warning',
          color: "warning",
          text: "Please ensure that you have entered a name AND a description for the link.",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info',
          time: 5500
        });
      }
    },
    backToTopic() {
      var self = this;
      self.$vs.loading.close(self.$refs.maindiv.$el);
      if (self.isTeacher)
        self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromAddContent: true }});  
      else
        self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromAddContent: true }});
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    }
  },
  mounted() {
    var self = this;
    self.initValues();

    self.selectedData = self.$route.params.selectedData;
    self.numberOfTasks = self.$route.params.numberOfTasks;
    self.isTeacher = self.$route.params.isTeacher;
  }
};
</script>

<style lang="scss">
.main-div {
  width: 65%;
}

@media screen and (max-width: 900px) {
  .main-div {
    width: 100%;
  }
}

.filepond--panel-root {
  border-radius: 0 6px 6px 0;
  background-color: rgba(255, 255, 255, 0) !important;
}

.filepond--drop-label {
  color:rgb(202, 202, 202) !important;
}

#linkName.vs-input--input {
  background: none !important;
  border: 5px solid rgba(192, 196, 212, 0.2) !important;
  border-radius: 20px !important;
  height: 55px !important;
  font-size: 1.4rem !important;
  color: rgb(202, 202, 202) !important;
}

#linkDesc.vs-textarea {
  background: rgba(var(--vs-background),1) !important;
  border-radius: 20px !important;
  border: 5px solid rgba(192, 196, 212, 0.2) !important;
  color: rgb(202, 202, 202) !important;
  font-size: 1rem !important;
  height: 90px !important;
}

// #linkDetails .vs-con-input-label {
//   width: 400px !important;
// }

#linkDetails .focusx.vs-textarea-primary {
  border: 0 solid rgba(0, 0, 0, 0) !important;
}

#linkDetails .vs-textarea-primary {
  border: 0 solid rgba(0, 0, 0, 0) !important;
}

.save__btn {
  border-radius: 15px !important;
}

#back-to-topic_btn {
  border-radius: 15px !important;
}

#link-input {
  + .vs-input--placeholder {
    height: 100% !important;
    padding-top: 0.95rem !important;
  }
}
</style>
